import * as Yup from 'yup';
import {
	VEHICLE_DETAILS_PART_ONE_ERROR_MESSAGES,
	VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES,
} from '@acorn-portal/shared/src/utils/constants/ErrorMessages';

import { FullPolicy } from '@acorn-portal/shared/src/services/api';
import { Product } from '@acorn-portal/shared/src/services/interface/Shared';
import { VEHICLE_REGISTRATION_REGEX } from '../constants/Regex';

const ChangeOfVehiclePart1Schema = ({ fullPolicy }: { fullPolicy: FullPolicy }) =>
	Yup.object().shape({
		vrm: Yup.string()
			.matches(VEHICLE_REGISTRATION_REGEX, VEHICLE_DETAILS_PART_ONE_ERROR_MESSAGES.validRegistration)
			.required(VEHICLE_DETAILS_PART_ONE_ERROR_MESSAGES.registrationRequired),
		bodyType: Yup.string().when([], {
			is: () => fullPolicy.product !== Product.TAXI,
			then: (schema) => schema.notRequired(),
			otherwise: (schema) => schema.required(VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES.bodyType),
		}),
	});

export default ChangeOfVehiclePart1Schema;
